import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { CSSProperties, MouseEvent, SyntheticEvent } from 'react'
import css from './Img.module.scss'

type Props = {
  className?: string
  fit?: boolean
  src?: string
  alt?: string
  style?: CSSProperties
  width?: number
  height?: number
  onClick?(event: MouseEvent): void
  onLoad?(event: SyntheticEvent<HTMLImageElement>): void
  onError?(event: SyntheticEvent<HTMLImageElement>): void
  onRef?(element: HTMLImageElement | null): void
}

export function fixImageUrl(src: string | undefined): string | undefined {
  if (!src) return src
  try {
    const url = new URL(src)
    if (url.host === 'dresscode-stage.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-stage.dresscode.ai'
    }
    if (url.host === 'dresscode-stage-2.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-stage.dresscode.ai'
    }
    if (url.host === 'dresscode-prod.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs.dresscode.ai'
    }
    if (url.host === 'dresscode-prod-2.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs.dresscode.ai'
    }
    if (url.host === 'mosaica-upload.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-ai.dresscode.ai'
    }
    if (url.host === 'mosaica-upload-2.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-ai.dresscode.ai'
    }
    if (url.host === 'imgs.atelierdigital.ai' || url.host === 'imgs.apiresq.com') {
      url.host = 'imgs.dresscode.ai'
    }
    const atelier = ['.atelierdigital.ai', '.apiresq.com'].find(d => location.host.endsWith(d))
    if (atelier && url.host === 'imgs.dresscode.ai') {
      url.host = 'imgs' + atelier
    }
    const showoff = location.host.endsWith('.showoff.app')
    if (showoff && url.host === 'imgs.dresscode.ai') {
      url.host = 'imgs.showoff.app'
    }
    return url.toString()
  } catch {
    return src
  }
}

export const Img = (props: Props) => {
  const { fit, alt, style, width, height, onClick, onLoad, onError } = props
  const className = clsx(props.className, fit && css.fit)
  const src = fixImageUrl(props.src ?? '')

  const onRef = useLatestCallback((element: HTMLImageElement | null) => {
    if (props.onRef) props.onRef(element)
  })

  return <img ref={onRef} className={className} style={style} src={src} alt={alt}
    width={width} height={height} onClick={onClick} onLoad={onLoad} onError={onError} />
}
